var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-banner",on:{"click":_vm.doClick}},[_c('div',{staticClass:"info-title-wrapper"},[_vm._t("left-content"),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})],2),_vm._t("right-content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }